var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "recruiting-card" },
    [
      _c(
        "router-link",
        {
          staticClass: "recruiting-card__link",
          attrs: { to: "/recruiting/" + _vm.opportunity._id }
        },
        [
          _c(
            "div",
            {
              staticClass: "recruiting-card__banner",
              style: _vm.communityStyle
            },
            [
              _c("span", { staticClass: "recruiting-card__title" }, [
                _vm._v(_vm._s(_vm.opportunity.title || "Untitled opportunity"))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    "status-pill",
                    "status-pill--" + _vm.opportunity.status
                  ]
                },
                [
                  _c("span", { staticClass: "status-pill__dot" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.statusLabel(_vm.opportunity.status)) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.isFavorited
                ? _c("i", {
                    staticClass:
                      "fa fa-star fa-lg gold-color recruiting-card__fav",
                    attrs: { "aria-hidden": "true", title: "Favorite" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "recruiting-card__engagement" }, [
                _vm._v(_vm._s(_vm.engaged) + " / " + _vm._s(_vm.sentTo))
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d11df54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d11df54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecruitingRow.vue
// module id = null
// module chunks = 